// ** React Imports
import { useEffect, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadActivityStore, ViewType, LeadAccountStore, LeadCompanyStore, SprintDialogStore, LeadSprintStore, LeadActivityHistoryStore, HistoryDetailsDialogStore, ActivityHistoryDialogStore, LeadActivityCadenceStore } from 'src/stores/LeadStore';
import { leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import _ from 'lodash';
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import MuiTimeline, { TimelineProps } from '@mui/lab/Timeline'
import TimelineDot from '@mui/lab/TimelineDot'
import TimelineItem from '@mui/lab/TimelineItem'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import Icon from 'src/features/common/CustomIcon'
import { previousDateDays } from 'src/utils/date-utils';
import Link from '@mui/material/Link';
import RadialBarChart from '../../common/RadialBarChart';
import Grid from '@mui/material/Grid';

// Styled Timeline component
const Timeline = styled(MuiTimeline)<TimelineProps>(({ theme }) => ({
    margin: 0,
    padding: 0,
    marginLeft: theme.spacing(0.75),
    '& .MuiTimelineItem-root': {
        '&:before': {
            display: 'none'
        },
        '&:last-child': {
            minHeight: 60
        }
    }
}))


const ActivityCadenceList = () => {
    const cadenceRecord = LeadActivityCadenceStore.useState(s => s.record);

    return <Card sx={{ mb: 6 }} data-testid="activity-timeline">
        <CardContent>
            <Timeline>
                {cadenceRecord.playbookCadenceSteps.map(record => (
                    <TimelineItem key={record.id} >
                        <TimelineSeparator>
                            <Tooltip title={record.currentActivityName} >
                                <TimelineDot variant="outlined" >
                                    <Icon icon={record.currentActivityIcon} sx={{ color: 'blue', fontSize: 20 }} ></Icon>
                                </TimelineDot>
                            </Tooltip>
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                            <Grid container spacing={2} alignContent={'flex-end'}>
                                <Grid item xs={12} md={6} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                    < Typography>
                                        {record.currentActivityName}
                                    </Typography>
                                    {record.processOrder == '1' && record.proccessWhen == 1 &&
                                        < Typography variant="caption" sx={{ mr: 1 }}>
                                            Due {record.proccessWhen} day after cadence is assigned
                                        </Typography>
                                    }
                                    {record.processOrder == '1' && record.proccessWhen != 1 &&
                                        < Typography variant="caption" sx={{ mr: 1 }}>
                                            Due {record.proccessWhen} days after cadence is assigned
                                        </Typography>
                                    }
                                    {record.processOrder != '1' && record.proccessWhen == 1 &&
                                        < Typography variant="caption" sx={{ mr: 1 }}>
                                            Due {record.proccessWhen} day after previous step
                                        </Typography>
                                    }
                                    {record.processOrder != '1' && record.proccessWhen != 1 &&
                                        < Typography variant="caption" sx={{ mr: 1 }}>
                                            Due {record.proccessWhen} days after previous step
                                        </Typography>
                                    }
                                    {cadenceRecord.currentStepProcessOrder.toString() == record.processOrder &&
                                        < Typography variant="overline" sx={{ mr: 1, color: 'CornflowerBlue' }}>
                                            Current Cadence Step
                                        </Typography>
                                    }
                                </Grid>
                                <Grid item xs={12} md={6} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                    <Box display="flex" justifyContent="flex-end">
                                        <RadialBarChart subHeading="Contact Rate" seriesValue={record.connectionRate} toolTip="Contact Rate of Current Cadence Step" />
                                    </Box>
                                </Grid>
                            </Grid>
                        </TimelineContent>
                    </TimelineItem>
                ))
                }
            </Timeline>
        </CardContent>
    </Card>
}

export { ActivityCadenceList }

export default ActivityCadenceList;